<template>
  <v-select
    class="font-weight-medium"
    title="Any"
    v-model="selectedData"
    :items="props.propsData"
    density="compact"
    variant="outlined"
    item-title="name"
    :label="props.boxName"
    item-value="id"
    @update:modelValue="clickHandler"
    persistent-hint
    multiple
  >
    <!-- <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 2">
            <span>{{ item.title }}</span>
          </v-chip></template
        > -->
    <template v-slot:prepend-item>
      <div v-if="props.propsData !== undefined && props.propsData.length !== 0">
        <v-list-item title="Select All" @click="toggle">
          <template v-slot:prepend>
            <v-checkbox-btn
              :color="'indigo-darken-4'"
              :indeterminate="SomeItems && !AllItems"
              :model-value="selectAllSubSubCatFlag"
            ></v-checkbox-btn>
          </template>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </div>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index < 2">
        <span>{{ item.title }}</span>
      </v-chip>
      <span v-if="index === 2" class="text-grey text-caption align-self-center">
        (+{{ selectedData.length - 2 }} others)
      </span>
    </template>
  </v-select>
</template>
<script setup>
import { defineProps, ref, watchEffect } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  propsData: {
    type: Array,
    default: () => [{ sectorID: 0, sectorName: "Any" }],
  },
  boxName: {
    type: String,
  },
});

const selectedData = ref(
  store.getters["Sector/getsubSubCategorySelectedGetters"]
);
// const selectedID = ref();
const disSelect = ref();
const previousSelectedStructures = ref([]);
const selectAllSubSubCatFlag = ref(false);
const selectedID = ref();
const view = ref([]);
watchEffect(() => {
  selectedData.value = store.getters["Sector/getsubSubCategorySelectedGetters"];
  // console.log("st", selectedData.value);
  //if (selectedData.value.length === props.propsData.length) {
  //selectAllSubSubCatFlag.value = true;
  //}
  // console.log(store.getters["Sector/getsubSubCategorySelectedGetters"], 66);
  // let dropdown = store.getters["Sector/getselectedDataGetters"];
  // if (Object.keys(dropdown).length > 0) {
  //   if (props.boxName === "Sub Sub Category") {
  //     if (dropdown["subSubCategoryID"] !== undefined) {
  //       selectedData.value = dropdown["subSubCategoryID"][0];
  //     }
  //   }
  // }
  // console.log(getsubSubCategorySelectedGetters)
  // selectAllFlag.value = store.getters["Sector/getSelectAllFlagGetters"];
  if (
    props.propsData !== undefined &&
    props.propsData !== null &&
    selectedData.value !== undefined &&
    selectedData.value !== null
  ) {
    // let flag = store.getters["Sector/getLastSearchActivatedGetters"];
    if (props.propsData.length === selectedData.value.length) {
      selectAllSubSubCatFlag.value = true;
      // toggle();
      selectedData.value.forEach((t) => {
        view.value.push(t.id);
      });
    } else {
      selectedData.value.forEach((t) => {
        view.value.push(t.id);
      });
      selectAllSubSubCatFlag.value = false;
    }
  }
});
function clickHandler(e) {
  // console.log(e);
  //   console.log(props.boxName);
  //   store.dispatch("Sector/setcategoryPayloadAct", e);
  store.dispatch("Sector/setLastSearchActivated", false);
  let catsubsubData = store.getters["Sector/getSubSubCategoryGetters"];
  const searchCry = {
    val: e,
    column: props.boxName,
    entirs: props.propsData,
  };
  store.dispatch("Rawdata/setSearchCritertia", searchCry);
  let subsubcatSelectedRec = [];
  // console.log(catsubsubData, "catsubsubData");
  catsubsubData.forEach((i) => {
    let found = e.includes(i.id);
    if (found) {
      subsubcatSelectedRec.push(i);
    }
  });
  store.dispatch("Sector/setsubsubcategorySelectedAct", subsubcatSelectedRec);
  let catPayload = store.getters["Sector/getcategoryPayload"];
  Object.keys(catPayload).find((key) => {
    if (key === "cat_ssub") {
      e.forEach((i) => {
        // const index = catPayload[key].indexOf(i.sectorID);
        // console.log(i.sectorID, "i");
        // if (index === -1) {
        if (!catPayload[key].includes(i)) {
          store.dispatch("Sector/setsubsubcategoryPayloadAct", i);
          // state.categoryPayload[key].push(i.sectorID);
          // }
        }
      });
    }
  });

  let ridersOriginal = store.getters["Rawdata/getDropdownDataAPI"].riders;
  let ridersDataNames = [];
  // console.log("3data", ridersOriginal, e);
  if (e.length > 0) {
    // console.log(11, e[0].id);
    for (let i = 0; i < ridersOriginal.length; i++) {
      let secidArray = ridersOriginal[i].riders_sectorID
        .split(",")
        .map((id) => id.trim());
      let status = !secidArray.includes(e.toString());
      if (!status) {
        ridersDataNames.push(ridersOriginal[i]);
      }
    }
  }
  // console.log("ridersDataNames", ridersDataNames);
  store.dispatch("Sector/setSectorIdsRiders", ridersDataNames);

  let issuesOriginal = store.getters["Rawdata/getDropdownDataAPI"].issue;
  let issueDataNames = [];
  if (e.length > 0) {
    // console.log(11, e[0].sectorID);
    for (let i = 0; i < issuesOriginal.length; i++) {
      let secidArray = issuesOriginal[i].sector_id
        .split(",")
        .map((id) => id.trim());
      let status = secidArray.includes(e.toString());
      if (status) {
        issueDataNames.push(issuesOriginal[i]);
      }
    }
  }
  // console.log(issueDataNames, "issueDataNames");
  store.dispatch("Sector/setIssueTypeData", issueDataNames);

  disSelect.value = previousSelectedStructures.value.filter(
    (item) => !e.includes(item)
  );
  // console.log("diselect", disSelect.value);
  let checkboxSelected = JSON.parse(JSON.stringify(view.value));
  // console.log(checkboxSelected, "vuiew");
  // console.log(checkboxSelected.length, "len");
  // console.log(view.value, "view");
  disSelect.value = null;
  selectedID.value = null;
  if (e.length >= view.value.length) {
    if (e.length != 0 && e !== undefined) {
      for (let i of e) {
        let found = !JSON.parse(JSON.stringify(checkboxSelected)).includes(i);
        if (found) {
          selectedID.value = i;
        } else {
          selectedID.value = i;
        }
      }
      view.value = e;
    }
  } else {
    if (view.value.length != 0 && view.value !== undefined) {
      for (let i of view.value) {
        let found = !JSON.parse(JSON.stringify(e)).includes(i);
        if (found) {
          disSelect.value = i;
        }
      }
      view.value = e;
    }
  }
  if (disSelect.value) {
    categoryDisSelectionHandler(disSelect.value);
  }
  previousSelectedStructures.value = e;
}

function toggle() {
  selectAllSubSubCatFlag.value = !selectAllSubSubCatFlag.value;
  disSelect.value = null;
  if (selectAllSubSubCatFlag.value) {
    selectedData.value = [];
    selectedData.value = props.propsData;
    store.dispatch("Sector/setsubcategorySelectedAct", props.propsData);
    // if (props.boxName === "Category") {
    //   selectedData.value.forEach((i, index) => {
    //     setTimeout(() => {
    //       switchSubCategoryFunctionCases(i.id, i.name);
    //     }, 1000 * index);
    //   });
    // } else if (props.boxName === "Sub Category") {
    //   selectedData.value.forEach((i, index) => {
    //     setTimeout(() => {
    //       switchSubCategoryFunctionCases(i.id, i.name);
    //     }, 1000 * index);
    //   });
    // } else if (props.boxName === "Sub Sub Category") {
    selectedData.value.forEach((i) => {
      view.value.push(i.id);
      let catPayload = store.getters["Sector/getcategoryPayload"];
      Object.keys(catPayload).find((key) => {
        if (key === "cat_ssub") {
          if (!catPayload[key].includes(i.id)) {
            store.dispatch("Sector/setsubsubcategoryPayloadAct", i.id);
          }
        }
      });
      // switchSubCategoryFunctionCases(i.id, i.name);
    });
    const searchCry = {
      val: view.value,
      column: props.boxName,
      entirs: props.propsData,
    };
    store.dispatch("Rawdata/setSearchCritertia", searchCry);
    // }
  } else {
    selectedData.value.forEach((i) => {
      categoryDisSelectionHandler(i.id);
    });
    selectedData.value = [];
    store.dispatch("Sector/setsubcategorySelectedAct", selectedData.value);
  }
}

function categoryDisSelectionHandler(disid) {
  // console.log(disid, "dis");
  store.dispatch("Sector/setunCheckSubSubcategoryPayloadAct", disid);
}
</script>
